export default __webpack_public_path__ + "static/neckband_m-7fef7d3f6876c5ac62ca1e4a60a76f88.png";